export default class CorePlayingStyles {
  static defensive = -1;
  static balanced = 0;
  static attacking = 1;
}
